module.exports = __webpack_public_path__ + "static/media/splash.13b9bef8.png";